import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'name',
    label: i18n('entities.sustainability.fields.name'),
    schema: schemas.string(
      i18n('entities.sustainability.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'message',
    label: i18n('entities.sustainability.fields.message'),
    schema: schemas.string(
      i18n('entities.sustainability.fields.message'),
      {},
    ),
  },
  {
    name: 'logos',
    label: i18n('entities.sustainability.fields.logos'),
    schema: schemas.relationToMany(
      i18n('entities.sustainability.fields.logos'),
      {},
    ),
  },
];